// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payment-field[data-v-d4416d7c] {\n  position: relative;\n  margin-bottom: 16px;\n  padding: 24px;\n  border: 1px solid #1BA7E1;\n  box-sizing: border-box;\n  box-shadow: 0px 4px 12px rgba(27, 167, 225, 0.15);\n  border-radius: 4px;\n  cursor: pointer;\n}\n.bank-img[data-v-d4416d7c] {\n  position: absolute;\n  right: 20px;\n  bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
